<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
      :columns="['Data Movimento', 'Número Conta Poupança', 'Data abertura da conta', 'Valor Saldo Ultimo dia Mês', 'Situação Conta Poupança']"
      :showTipFooter="false"
      v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" :status="1" :value="obj.dataMovimento ? formatDate(obj.dataMovimento) : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.numContaPoupanca" />
        <TableColumn :IsText="true" :status="1" :value="obj.dataAberturaContaPoupanca ? formatDate(obj.dataAberturaContaPoupanca) : ''" />
        <TableColumn :IsText="true" :status="1" :value="obj.valSaldoUltimoDiaMes ? formatValue(obj.valSaldoUltimoDiaMes) : 'R$ 0,00'" />
        <TableColumn :IsText="true" :status="1" :value="obj.situacaoContaPoupanca" />
      </tr>
    </Tables>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'
import ContaPoupancaRepository from '@/shared/http/repositories/business/contaPoupanca.js'
import Tools from '@/components/tools/Tools.js'

export default {
  name: 'ContaPoupanca',
  mixins: [ActionsForm],
  data () {
    return {
      document: null
    }
  },
  methods: {
    onLoad () {
      if (this.document) {
        this.onLoadContaPoupanca(this.document)
      }
    },
    onLoadContaPoupanca (document) {
      loading.push()
      this.document = document
      ContaPoupancaRepository.Search(document, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    formatValue (value) {
      let result
      if (value) {
        result = Tools.formatMoneyBR(value.toString())
      }
      return result
    },
    formatDate (value) {
      let result = ''
      if (value) {
        result = this.moment(value).format('DD/MM/YYYY')
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/associate/tabs/ContaPoupanca.vue